module.exports = __webpack_public_path__ + "img/rule-ar.de6288da.png";